import {
  ElMerkleRootResponse,
  TVLResponse,
  TotalKMELPointsResponse,
} from "@services/index";
import { UseQueryResult } from "@tanstack/react-query";
import { useMemo } from "react";
import SCard from "./SCard";
import { numberToCurrency } from "utils";
import { formatEther } from "ethers/lib/utils.js";
import { Avatar, Flex, Text } from "@chakra-ui/react";

interface KelpStatsProps {
  tvl: UseQueryResult<TVLResponse, Error>;
  kelp: UseQueryResult<TotalKMELPointsResponse, Error>;
  elMerkleRoot: UseQueryResult<ElMerkleRootResponse, Error>;
}

function getTotalKelpMiles() {
  const BASE_VALUE = 285_000_000_000;
  const CHANGE_PER_HOUR = (5 * 1_000_000_000) / 24;
  const STARTING_TIME = Date.parse(
    "Thu Apr 11 2024 13:22:36 GMT+0530 (India Standard Time)"
  );

  const now = Date.now();
  const hoursSinceStart = (now - STARTING_TIME) / (1000 * 60 * 60);
  return BASE_VALUE + CHANGE_PER_HOUR * hoursSinceStart;
}

const KelpStatsCard = ({ tvl, elMerkleRoot }: KelpStatsProps) => {
  const items = useMemo(() => {
    return [
      {
        label: "TVL",
        value: tvl.data?.usdTvl
          ? `$${numberToCurrency(`${tvl.data.usdTvl}`, 0)}`
          : "-",
        icon: "tvl.svg",
      },
      {
        label: "Total EL Points",
        value: elMerkleRoot.data?.data.totalElPoints
          ? `${numberToCurrency(
              formatEther(
                // eslint-disable-next-line no-undef
                BigInt(Number(elMerkleRoot.data?.data.totalElPoints)).toString()
              ),
              0
            )}`
          : "-",
        icon: "eigen.svg",
      },
      {
        label: "Total Kelp Grand Miles",
        value: `${numberToCurrency(
          (getTotalKelpMiles() / 1000).toString(),
          0
        )}`,
        icon: "kelp-miles.svg",
      },
      // {
      //   label: "Kelp Miles",
      //   value: kelp.data?.value.points.kelpMiles
      //     ? numberToCurrency(
      //         formatEther(
      //           BigNumber.from(
      //             Number(kelp.data.value.points.kelpMiles).toLocaleString(
      //               "fullwide",
      //               { useGrouping: false }
      //             )
      //           ).toString()
      //         )
      //       )
      //     : undefined,
      //   icon: "kelp-miles.svg",
      // },
      // {
      //   label: "EigenLayer Points",
      //   value: kelp.data?.value.points.eigenLayerPoints
      //     ? numberToCurrency(kelp.data.value.points.eigenLayerPoints)
      //     : undefined,
      //   icon: "el-points.svg",
      // },
    ];
  }, [tvl.data, elMerkleRoot.data]);

  return (
    <SCard title="Kelp Stats">
      <Flex direction="column" gap={4}>
        {items.map((item, index) => (
          <div key={index}>
            {item.value ? (
              <Flex key={item.label} gap={4} alignItems="center">
                <Avatar
                  w={9}
                  h={9}
                  src={`/assets/right-sidebar/${item.icon}`}
                />
                <Flex
                  lineHeight={1.3}
                  direction={{
                    base: "row-reverse",
                    xl: "column",
                  }}
                  justify="space-between"
                  flex={1}
                >
                  <Text fontWeight={700} fontSize={14} color="#075A5A">
                    {item.value}
                  </Text>
                  <Text fontSize={12} color="#3F6870" whiteSpace={"nowrap"}>
                    {item.label}
                  </Text>
                </Flex>
              </Flex>
            ) : null}
          </div>
        ))}
      </Flex>
    </SCard>
  );
};

export default KelpStatsCard;
